// deps
import React, { memo } from "react";

// internal-deps
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// styles
import {
    ContentContainer,
    ContentWrapper,
    HalfCardContentWrapper,
    HalfCardWrapper,
    StyledButton,
    StyledStepperImage,
    StyledTitleText,
} from "./styles";

// test-ids
import { BILL_DETAILS_BANNER_TEST_IDS } from "@swiggy-private/cart-test-ids";

// constants
import { DIMENSIONS } from "./constants";

export interface BillDetailsBannerHalfCardProps {
    isOpen?: boolean;
    icon?: string;
    title?: string;
    content?: string[];
    ctaText?: string;
    clickHandler?: VoidFunction;
}

const BillDetailsBannerHalfCard = ({
    isOpen,
    icon,
    title,
    content,
    ctaText,
    clickHandler,
}: BillDetailsBannerHalfCardProps) => {
    return (
        <HalfCard isOpen={isOpen ?? false} closeOnOverlayClick hasCustomPadding variant="v3" onClose={clickHandler}>
            <HalfCardWrapper data-testid={BILL_DETAILS_BANNER_TEST_IDS.HALF_CARD.CONTAINER}>
                <HalfCardContentWrapper>
                    <Image
                        cloudinaryId={icon}
                        width={DIMENSIONS.BANNER_IMAGE.WIDTH}
                        height={DIMENSIONS.BANNER_IMAGE.HEIGHT}
                    />
                    <StyledTitleText
                        variant="V2.heading1.neutral.black"
                        color="text_Highest_Emphasis"
                        data-testid={BILL_DETAILS_BANNER_TEST_IDS.HALF_CARD.TITLE}
                    >
                        {title}
                    </StyledTitleText>
                    <ContentWrapper data-testid={BILL_DETAILS_BANNER_TEST_IDS.HALF_CARD.CONTENT_WRAPPER}>
                        <StyledStepperImage
                            cloudinaryId="portal/static-assets/icons/Stepper.png"
                            width={DIMENSIONS.STEPPER_IMAGE.WIDTH}
                            height={DIMENSIONS.STEPPER_IMAGE.HEIGHT}
                        />
                        <ContentContainer>
                            {content?.map((text) => (
                                <Text
                                    variant="V2.body2.neutral.regular"
                                    color="text_High_Emphasis"
                                    key={text}
                                    data-testid={BILL_DETAILS_BANNER_TEST_IDS.HALF_CARD.CONTENT_TEXT}
                                >
                                    {text}
                                </Text>
                            ))}
                        </ContentContainer>
                    </ContentWrapper>
                </HalfCardContentWrapper>
                <StyledButton
                    variant="fullwidth"
                    buttonType="primary"
                    buttonSize="medium"
                    onClick={clickHandler}
                    data-testid={BILL_DETAILS_BANNER_TEST_IDS.HALF_CARD.CTA_BUTTON}
                >
                    {ctaText}
                </StyledButton>
            </HalfCardWrapper>
        </HalfCard>
    );
};

export default memo(BillDetailsBannerHalfCard);
